module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.display,
      "persistent": "",
      "max-width": _vm.width
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.text) ? _c('v-card-text', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.color(this.danger)
    },
    on: {
      "click": _vm.okHandler
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.okText) + "\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey lighten-1",
      "flat": ""
    },
    on: {
      "click": _vm.cancelHandler
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cancelText) + "\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6ac9be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmBox.vue
// module id = 13
// module chunks = 0